import React, { Component } from 'react';
//import EventImg from '../../assets/images/yoga.png';
import AppUtils from '../../apputils';
const img_path = 'https://www.kinshipliving.com/images/uploads/kinship/events/';


export default class EventsList extends Component {
    // constructor(props) {
    //     super(props)
    // }

    HandleRouting = (route) => {
            AppUtils.HandlePageClick(this.props.componentprops, route)
    }




    HandleDate = (startDate) => {
        startDate = startDate.replace(/  /g, 'T')
        const dayArray = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        const monthArray = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        let final_date;
        var day = new Date(startDate).getDay();
        var date = new Date(startDate).getDate();
        var month = new Date(startDate).getMonth();

        final_date = dayArray[day] + ',' + monthArray[month] + ' ' + date;

        return final_date;
    }

    HandleTime = (startTime) => {
        startTime = startTime.replace(/  /g, 'T')
        var hr = new Date(startTime).getHours();
        var min = new Date(startTime).getMinutes();
        let final;

        if (hr > 12) {
            hr = hr - 12
            if (min < 10) {
                min = '0' + min;
            }
            final = hr + ':' + min + ' ' + 'PM';
        }
        else {
            if (min < 10) {
                min = '0' + min;
            }
            final = hr + ':' + min + ' ' + 'AM';
        }

        return final;
    }


    render() {
        return (
            <div>
                <div className="container-fluid">
                    <div className="event-list-main-div">
                        <div className="row">
                            <div className="col-md-12 col-lg-12">
                                <div className="row" style={{ marginLeft: '0' }} >
                                    <div className="" style={{ cursor: 'pointer' }} onClick={() => this.HandleRouting('upcoming-sessions')}>
                                        <h4>Upcoming Live Sessions</h4>
                                    </div>

                                    <div className="orders-head-line"></div>
                                    <p class="display-none" onClick={() => this.HandleRouting('upcoming-sessions')}>View all</p>
                                    <i class="fa fa-arrow-right orders-head-arrow" aria-hidden="true" style={{ cursor: 'pointer' }} onClick={() => this.HandleRouting('upcoming-sessions')}></i>
                                </div>


                            </div>

                            <div class="event-list-mobile" >
                                {
                                    this.props.upcomingEventsList.length > 0 ?

                                        this.props.upcomingEventsList.map((item, i) => (


                                            <div key={i}>
                                                <div class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12" >
                                                    <div class="row" onClick={() => this.HandleRouting(`session-details/${item.seo_url}`)}>
                                                        <div class="col-6 col-xs-6 col-sm-6">
                                                            <div className="event-image">
                                                                <img src={img_path + item.event_image.replace(',', '')} alt="loading...." />
                                                            </div>
                                                        </div>

                                                        <div class="col-6 col-xs-6 col-sm-6">
                                                            <div className="event-date">
                                                                <h5>{this.HandleDate(item.event_start_time)} </h5>
                                                                <h5>{this.HandleTime(item.event_start_time)}</h5>
                                                                <p>{item.event_duration} mins</p>
                                                                <span>{item.event_total_seats - (item.event_filled_seats + item.event_already_filled_seats)} seats left</span>
                                                            </div>
                                                            <div className="event-description">
                                                                <h6>{item.event_name + ' '}(<span>{item.event_language}</span>)</h6>

                                                            </div>
                                                        </div>


                                                    </div>
                                                </div>
                                                {i < this.props.upcomingEventsList.length - 1 ?
                                                    <div class="col-12">
                                                        <div className="seperation-line"></div>
                                                    </div>
                                                    : ''}
                                            </div>
                                        ))

                                        : ''}

                            </div>
                            <div class="event-list-desktop">
                                {this.props.upcomingEventsList.length > 0 ?

                                    this.props.upcomingEventsList.map((item, i) => (

                                        <div key={i}>
                                            <div className="col-md-12 col-lg-12">
                                                <div className="event-list" onClick={() => this.HandleRouting(`session-details/${item.seo_url}`)} >
                                                    <div className="row">
                                                        <div className="col-sm-2 col-md-2 col-lg-2">
                                                            <div className="event-date">
                                                                <h5>{this.HandleDate(item.event_start_time)} </h5>
                                                                <h5>{this.HandleTime(item.event_start_time)}</h5>
                                                                <p>{item.event_duration} mins</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-3 col-md-3 col-lg-3">
                                                            <div className="event-image">
                                                                <img src={img_path + item.event_image.replace(',', '')} alt="loading...." />
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-7 col-md-7 col-lg-7">
                                                            <div className="event-description">
                                                                <h6>{item.event_name + ' '}(<span>{item.event_language}</span>)</h6>
                                                                <p>{item.event_desc}</p>
                                                                <p style={{ color: '#e22a40' }}>{item.event_total_seats - (item.event_filled_seats + item.event_already_filled_seats)} seats left</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {i < this.props.upcomingEventsList.length - 1 ?
                                                <div className="col-md-12 col-lg-12">
                                                    <div className="seperation-line"></div>
                                                </div>
                                                : ''}
                                        </div>
                                    ))
                                    : ''}


                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}